import { FETCH_ADMINCANIDATES, FETCH_CANIDATES } from '../constants/actionTypes'
import { dispatch } from '../store/'
import { db } from '../firebase/firebase'
import _ from 'lodash'
//import { app } from 'firebase';
//import { helper}  from '../js/helper'
import moment from 'moment'
import { doDeleteApplication } from '../firebase/database/handleApplications'

const refCanidates = db.ref('/canidates')
const refEvents = db.ref('/events')
const refUsers = db.ref('/users')


export const fetchAdminCanidateList = async () => {
    refCanidates.on('value', async canidatesSnap => {

        const collectEventsArr = []
        if(canidatesSnap.exists()) {
            const data = await canidatesSnap.val()
            Object.keys(data).map(async key =>{
               if(key!=='name'){
                const eventId = key
                const userIds = data[key]
                    const eventsSnap= await refEvents.child(eventId).once('value')
                    const event = await eventsSnap.val()
                    const requesterId = event.data.userId
                    
                    const requesterData = await fetchRequester(requesterId)
                    
                    const bindUserToEvent = {
                        event: event.data,
                        canidates: userIds,
                        requester: requesterData
                    }   
                    await collectEventsArr.push(bindUserToEvent)
                }
                
                const payload = collectEventsArr
                await dispatch({type: FETCH_ADMINCANIDATES, payload})
               })
        
        }

    })
}

export const fetchRequester = async (userId) => {
    const usersSanp = await refUsers.child(userId).once('value')
    return usersSanp.val()
    
}

export const fetchCanidates = async (canidatesIds) => {
        const canidatesArr = []
      
    const canidatesMapPromise = _.map(canidatesIds, async (eventId, key)=>{
        const canidateSnap = await refUsers.child(key).once('value')
      
        await canidatesArr.push(canidateSnap.val())
        return await canidatesArr
    })
    await Promise.all (canidatesMapPromise)
    await dispatch({type: FETCH_CANIDATES, canidatesArr})
    
}

export  const handleConnectCanidate = async (data) => {
    const {canidateId, canidateName, adminId, adminName, requesterName, event, canidatesOnWait} = data
    const timeStamp = moment().format()
   
    const updates = {}
    Object.keys(canidatesOnWait).map(canidateId=>doDeleteApplication(event.id, canidateId))
   
    updates['/myEvents/' + event.userId + '/' + event.id + '/eventId'] = null
    const messagePushKey = await db.ref('/messages/' + canidateId).child('inbox').push().key;
    const connectedEventData = {
        canidate: {
            id: canidateId,
            name: canidateName,
        },
        admin: {
            id: adminId,
            name: adminName,
            type: 'connected',
            timeStamp: timeStamp,
        },
        requester: {
            requesterId: event.userId,
            requesterName: requesterName,
        },
        event: event,
        canidatesOnWait: canidatesOnWait,
        messageId: messagePushKey,
    }
    updates['/connectedEvents/' + event.id ] = connectedEventData
    updates['/events/' + event.id] = null
    //const messagePushKey = await db.ref('/messages/' + canidateId).child('inbox').push().key;
    // prepare messages for requester canidate and admins
    //const messageContent = {}}
    
    const canidateMessage = {
        type: 'connectedEvent',
        timeStamp: timeStamp,
        sender: 'Verwaltung',
        data: {
            requesterName: requesterName,
            canidateName: canidateName,
            adminName: adminName,
            eventTask: event.task,
            eventDate: event.date,
        },
        ids: {
            eventId: event.id,
            senderId: adminId,
            reciptionId: canidateId,
            messageId: messagePushKey,
            requesterId: event.userId,
            },
        event: connectedEventData,
    
    }

    canidateMessage.body = 'Lieber Helfer, dein Hilfeangebot wurde vermittelt. Bitte nimm mit unserem Mitglied Kontakt auf und bestätige den Termin'
    canidateMessage.subject = 'Hilfeangebot vermittelt!'
 
    /*const adminMessage = {
        type: 'connectedEvent',
        eventId: event.id,
        senderId: adminId,
        reciptionIds: {
                        canidateId: canidateId,
                        requesterId: event.userId
                    },
        messageId: messagePushKey
    }*/
    //updates['/messages/admins/inbox/' + messagePushKey] = adminMessage
   // updates['/messages/' + event.userId + '/inbox/' + pushKey] = requesterMessage
    updates['/messages/' + canidateId + '/inbox/' + messagePushKey] = canidateMessage
    db.ref().update(updates)
}







// WEBPACK FOOTER //
// ./src/actions/adminCanidates.js